import { render, staticRenderFns } from "./Bluecard.vue?vue&type=template&id=580e19c8&scoped=true&"
import script from "./Bluecard.vue?vue&type=script&lang=ts&"
export * from "./Bluecard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e19c8",
  null
  
)

export default component.exports